import { use, useEffect, useState } from "react";
import contractServices from "../Contracts/contractServices";
import Drawer from 'react-modern-drawer';
import PeriodSelectionForm from "components/PeriodSelection/periodSelectionForm";
import { Filter } from "filter";
import { format } from "date-fns";
import { CommonUtilities } from "commonUtils";

export default function IndicatorDetail(detail: any) {

    console.log("IndicatorDetail")
    console.log(detail)

    let [reportingTo, setreportingTo] = useState("");
    let [reportingFrom, setreportingFrom] = useState("");
    let [contractDetail, setContractDetail] = useState<any>([]);
    let [periodSelection, setperiodSelection] = useState(false);
    let [indicatorDetail, setIndicatorDetail] = useState<any>([]);

    let [indicatorHeader, setIndicatorHeader] = useState<any>([]);
    let [indicatorOriginal, setIndicatorOriginal] = useState<any>([]);
    let [indicatorVisibility, setIndicatorVisibility] = useState<any>([]);
    let [indicatorTotalRows, setIndicatorTotalRows] = useState(0);

    const closeIndicatorDrawer = () => {
        detail.closeIndicatorDrawer()
    }


    useEffect(() => {

        if (detail?.paramDetail?.period && detail?.paramDetail?.period?.periodTo) {

            var period = Filter.DateTimeFormatNumber(detail?.paramDetail?.period && detail?.paramDetail?.period?.periodTo)
            contractPayload.periodTo = period.toString()
            reportingTo = period.toString();
            setreportingTo(reportingTo);
        }
        if (detail?.paramDetail?.period && detail?.paramDetail?.period?.periodFrom) {

            var period = Filter.DateTimeFormatNumber(detail?.paramDetail?.period && detail?.paramDetail?.period?.periodFrom)
            contractPayload.periodFrom = period.toString()
            reportingFrom = period.toString();
            setreportingFrom(reportingFrom);
        }


        if (detail?.paramDetail?.contract) {
            contractServices.overview({ contractRefNum: detail?.paramDetail?.contract }).then((respond: any) => {
                contractDetail = respond
                setContractDetail(contractDetail)
            })

            contractIndicatorList();
        }

    }, [detail]);

    var contractPayload = {
        contractRefNum: detail?.paramDetail?.contract,
        export: 0,
        indicatorCode: "period_balance",
        pageNumber: 1,
        pageSize: 10,
        periodFrom: "20240101",
        periodTo: "20241231",
        searchFor: "",
    }

    const contractIndicatorList = () => {

        contractServices.contractIndicator(contractPayload).then((respond: any) => {
            indicatorTotalRows = respond.totalRows
            setIndicatorTotalRows(indicatorTotalRows)

            setIndicatorOriginal(CommonUtilities.objectreMap(respond.headers.original));
            setIndicatorHeader(CommonUtilities.objectreMap(respond.headers.display));
            setIndicatorVisibility(CommonUtilities.objectreMap(respond.headers.visible));


            indicatorDetail = CommonUtilities.relativeDataRemapping(respond.data, respond.headers.original)
            setIndicatorDetail(indicatorDetail)
        })
    }

    const contractIndicatorExport = () => {
        contractPayload.export = 1
        contractPayload.indicatorCode = (contractPayload.indicatorCode).replace(" ", "_")
        contractPayload.pageSize = 10000
        var fileName = detail?.indicatorSelected ?? "Indicator"
        contractServices.contractIndicatorExport(contractPayload, fileName)
    }

    const closePeriod = (e: any) => {
        periodSelection = false;
        setperiodSelection(false)
    }

    const onChange = (period: any) => {

        console.log(period)
        if (period.periodFrom) {
            reportingFrom = period.periodFrom.year + format(new Date(period.periodFrom.month), 'MMdd');
            setreportingFrom(period.periodFrom.year + format(new Date(period.periodFrom.month), 'MMdd'));
            contractPayload.periodFrom = reportingFrom
        }

        if (period.periodTo) {
            reportingTo = period.periodTo.year + format(new Date(period.periodTo.month), 'MMdd');
            setreportingTo(period.periodTo.year + format(new Date(period.periodTo.month), 'MMdd'));
            contractPayload.periodTo = reportingTo
        }

        if (period && period.action && period.action === 2) {
            contractIndicatorList();
        }


    }


    return (<>


        <Drawer
            open={detail.indicatorDetail}
            direction='right'
            className='react-drawer'
            onClose={closeIndicatorDrawer}
            size={800}>

            <div className="ws-8 pull-right ">
                <div className="ws-12 box landing full-height-vh100">
                    <div className="box-header-main">
                        <h2>{detail?.indicatorSelected ?? "Indicator"}</h2>
                    </div>

                    <div className="box-content">
                        <div className="ws-12 pm pts" data-ng-show="contractRefNum">
                            <fieldset className="scheduler-border p0 m0">
                                <legend className="scheduler-border">
                                    <h2>Contract Info </h2>
                                </legend>

                                <div className="ws-12 pm">

                                    <div className="ws-4">
                                        <label className="control-label ws-5 text-right text-bold" > Contract Code :</label>
                                        <div className="label-entries ws-7 text-center"> {contractDetail?.contractRefNum} </div>
                                    </div>

                                    <div className="ws-4">
                                        <label className="control-label ws-5 text-right text-bold" > Contract Name : </label>
                                        <div className="label-entries ws-7 text-center">{contractDetail?.contractTitle}  </div>

                                    </div>

                                    <div className="ws-4">
                                        <label className="control-label ws-5 text-right text-bold" > Contract Status:</label>
                                        <div className="label-entries ws-7 text-center">  {contractDetail?.contractStatus}</div>
                                    </div>
                                </div>

                            </fieldset>
                        </div>

                        <div className="ws-12 pm">
                            <div className="ws-5">
                                <label className="control-label ws-12 text-bold">Reporting Start Date</label>
                                <input className="ws-10" value={reportingFrom} disabled />
                            </div>

                            <div className="ws-5">
                                <label className="control-label ws-12 text-bold">Reporting End Date</label>
                                <input className="ws-10" value={reportingTo} disabled />
                            </div>

                            <button className="icon-btn edit ptl mtll" type="button" onClick={() => setperiodSelection(true)} title="Select Period">
                                <i className="icon-calendar"></i>
                            </button>
                        </div>

                        <div className="ws-12 box allowHscroll allowVscroll">

                            {indicatorTotalRows > 0 && indicatorHeader && <table className="newTable allowHscroll allowVscroll ws-12">
                                <thead>
                                    <tr>
                                        {indicatorHeader?.map((values: any, index: any) => {
                                            if (values !== 'totalRow' && indicatorVisibility[index] !== 0) {
                                                return (<>
                                                    <th className="forceSingleLine">
                                                        <span className="forceSingleLine">{values} </span>
                                                    </th>
                                                </>)
                                            }
                                        })}
                                    </tr>
                                </thead>

                                <tbody>

                                    {indicatorDetail?.map((Datavalues: any, index: any) => {
                                        return (
                                            <tr>
                                                {indicatorOriginal?.map((values: any, index: any) => {
                                                    if (values !== 'totalRow' && indicatorVisibility[index] === 1) {
                                                        return (<td >

                                                            {(() => {
                                                                if (typeof (Datavalues[values]) === "string") {
                                                                    return (Datavalues[values])
                                                                }

                                                                if (typeof (Datavalues[values]) === "number") {
                                                                    return (Datavalues[values].toFixed(2))
                                                                }

                                                            })()}

                                                        </td>)
                                                    }
                                                })}
                                            </tr>
                                        )
                                    })}
                                </tbody>

                            </table>}
                        </div>
                    </div>

                    <div className="box-footer">
                        <button className="icon-btn delete" onClick={closeIndicatorDrawer}> Close</button>
                        <button className="icon-btn info" onClick={contractIndicatorExport}>Export Summary  </button>
                    </div>

                </div>

                {(() => {
                    if (periodSelection === true) {
                        return <PeriodSelectionForm open={periodSelection} closePeriod={closePeriod} onChange={onChange} periodFrom={reportingFrom} periodTo={reportingTo} />;
                    }
                })()}

            </div>


        </Drawer>
    </>)

}